module.exports = __webpack_public_path__ + "h5/img/live-logo.4f06a99f.gif";